/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_TokenInputs */

const cs_sklik_token = /** @type {(inputs: Sklik_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Drak token`)
};

const en_sklik_token = /** @type {(inputs: Sklik_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Drak token`)
};

/**
* | output |
* | --- |
* | "API Drak token" |
*
* @param {Sklik_TokenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_token = /** @type {((inputs?: Sklik_TokenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_TokenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_token(inputs)
	return cs_sklik_token(inputs)
});